const PREFIX = '/pay'
export const CASES_PREFIX = `${PREFIX}/cases`
export const BOOTBOX_PREFIX = `${PREFIX}/bootbox`
export const BOOTBOX_CHECKIN = `${BOOTBOX_PREFIX}/checkin/:bootbox`
export const CASELESS_PREFIX = `${PREFIX}/caseless`
export const HOME = `${PREFIX}`
export const MANUAL_SEARCH = `${PREFIX}/manual-search`
export const MANUAL_SEARCH_AREA = `${MANUAL_SEARCH}/:area`
export const SCAN_SEARCH = `${PREFIX}/scan-search`
export const CASELESS_SEARCH = `${PREFIX}/caseless-search`
export const CASELESS_SEARCH_LOCATION = `${PREFIX}/caseless-search/:location`
export const CASELESS_DETAIL = `${CASELESS_PREFIX}/detail`
export const CASELESS_CHECKOUT = `${CASELESS_PREFIX}/checkout`
export const CASELESS_PAYMENT_SUCCESS = `${CASELESS_PREFIX}/:operation/success`
export const CASE_DETAIL = `${CASES_PREFIX}/:slug`
export const CASE_CHECKOUT = `${CASES_PREFIX}/:slug/checkout`
export const CASE_SUCCESS = `${CASES_PREFIX}/:slug/success`
export const CASE_RELEASE = `${CASES_PREFIX}/:slug/release`
export const CASE_RELEASE_SUCCESS = `${CASES_PREFIX}/:slug/release/success`
export const CASE_RELEASE_DROP_OFF = `${CASES_PREFIX}/:slug/release/dropoff`
export const MAINTENANCE_MODE = `${PREFIX}/maintenance-mode`

export const bootboxCheckinUrl = (bootbox) =>
  BOOTBOX_CHECKIN.replace(':bootbox', bootbox)

export const caseDetailUrl = (immobilizationCase) =>
  CASE_DETAIL.replace(':slug', immobilizationCase.slug)

export const caseCheckoutUrl = (immobilizationCase) =>
  CASE_CHECKOUT.replace(':slug', immobilizationCase.slug)

export const caseSuccessUrl = (immobilizationCase) =>
  CASE_SUCCESS.replace(':slug', immobilizationCase.slug)

export const caseReleaseUrl = (immobilizationCase) =>
  CASE_RELEASE.replace(':slug', immobilizationCase.slug)

export const caseReleaseSuccessUrl = (immobilizationCase) =>
  CASE_RELEASE_SUCCESS.replace(':slug', immobilizationCase.slug)

export const caseReleaseDropOffUrl = (immobilizationCase) =>
  CASE_RELEASE_DROP_OFF.replace(':slug', immobilizationCase.slug)

export const caselessPaymentSuccesslUrl = (operationId) =>
  CASELESS_PAYMENT_SUCCESS.replace(':operation', operationId)

export default HOME
